/**
 * Inline stroke icons. Bundling the handful of shapes the content uses keeps the
 * page free of icon font or sprite requests.
 */
const PATHS: Record<string, string[]> = {
  shield: ['M12 3l7 3v5.2c0 4.4-2.9 7.6-7 8.8-4.1-1.2-7-4.4-7-8.8V6l7-3z'],
  check: ['M4.5 12.5l4.8 4.8L19.5 7'],
  star: ['M12 3.8l2.5 5.2 5.7.8-4.1 4 1 5.7-5.1-2.7-5.1 2.7 1-5.7-4.1-4 5.7-.8z'],
  clock: ['M12 3a9 9 0 100 18 9 9 0 000-18z', 'M12 7.5v5l3.5 2'],
  phone: [
    'M6.6 3.5h2.9l1.5 3.9-2 1.4a11.2 11.2 0 004.8 4.8l1.4-2 3.9 1.5v2.9a2 2 0 01-2.2 2A16.2 16.2 0 014.6 5.7a2 2 0 012-2.2z',
  ],
  mail: ['M4 5.5h16a1.5 1.5 0 011.5 1.5v10a1.5 1.5 0 01-1.5 1.5H4A1.5 1.5 0 012.5 17V7A1.5 1.5 0 014 5.5z', 'M3 7l9 6 9-6'],
  'map-pin': ['M12 21c4.3-4.2 6.5-7.5 6.5-10a6.5 6.5 0 10-13 0c0 2.5 2.2 5.8 6.5 10z', 'M12 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z'],
  'arrow-right': ['M4 12h14.5', 'M13 6.5l6 5.5-6 5.5'],
  'chevron-down': ['M6.5 9.5l5.5 5.5 5.5-5.5'],
  'chevron-right': ['M9.5 6l6 6-6 6'],
  menu: ['M4 7h16', 'M4 12h16', 'M4 17h16'],
  x: ['M6.5 6.5l11 11', 'M17.5 6.5l-11 11'],
  car: [
    'M4.5 15l1.6-5.6A2 2 0 018 8h8a2 2 0 011.9 1.4L19.5 15',
    'M3.5 15h17v3.5h-2.2',
    'M6.2 18.5H3.5V15',
    'M8.5 18.5a1.8 1.8 0 10-3.6 0 1.8 1.8 0 003.6 0z',
    'M19.1 18.5a1.8 1.8 0 10-3.6 0 1.8 1.8 0 003.6 0z',
  ],
  home: ['M4 10.6L12 4l8 6.6V20a1 1 0 01-1 1h-4.5v-6h-5v6H5a1 1 0 01-1-1z'],
  building: ['M6 21V4.5A1.5 1.5 0 017.5 3h9A1.5 1.5 0 0118 4.5V21', 'M3.5 21h17', 'M9.5 7.5h1.5', 'M13 7.5h1.5', 'M9.5 11.5h1.5', 'M13 11.5h1.5', 'M10 21v-4.5h4V21'],
  plane: ['M20.5 3.5L3.5 10.8l6.6 2.6 2.6 6.6z', 'M20.5 3.5l-8.4 8.4'],
  heart: ['M12 20.3C7.6 17.3 4.5 14.3 4.5 10.8A3.8 3.8 0 0112 8.2a3.8 3.8 0 017.5 2.6c0 3.5-3.1 6.5-7.5 9.5z'],
  activity: ['M3 12.5h3.8L9.5 6l4 12 2.6-5.5H21'],
  users: [
    'M9.5 11.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z',
    'M2.5 20.5c0-3.7 3.1-6.5 7-6.5s7 2.8 7 6.5',
    'M16 5.4a3.5 3.5 0 010 6.4',
    'M17.8 14.4c2.2.9 3.7 2.9 3.7 5.4',
  ],
  briefcase: ['M4.5 7.5h15A1.5 1.5 0 0121 9v9.5a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 18.5V9a1.5 1.5 0 011.5-1.5z', 'M9 7.5V6a2 2 0 012-2h2a2 2 0 012 2v1.5', 'M3 12.5h18'],
  truck: ['M2.5 7.5h11v9h-11z', 'M13.5 10.5h3.8l3.2 3.2v2.8h-7', 'M8.3 18.3a1.8 1.8 0 10-3.6 0 1.8 1.8 0 003.6 0z', 'M18.8 18.3a1.8 1.8 0 10-3.6 0 1.8 1.8 0 003.6 0z'],
  scale: ['M12 4.5v3', 'M4 8.5l8-2 8 2', 'M7 8.5l-2.6 6h5.2z', 'M17 8.5l-2.6 6h5.2z', 'M8 20.5h8'],
  droplet: ['M12 3.5c3.4 3.8 6 7.2 6 10a6 6 0 01-12 0c0-2.8 2.6-6.2 6-10z'],
  package: ['M12 3l8 4.4v9.2L12 21l-8-4.4V7.4z', 'M4 7.4l8 4.4 8-4.4', 'M12 11.8V21'],
  bolt: ['M13.5 3L5.5 14H11l-1 7 8-11h-5.5z'],
  gift: ['M3.5 8.5h17V20a1 1 0 01-1 1h-15a1 1 0 01-1-1z', 'M3.5 13h17', 'M12 8.5V21', 'M12 8.5S11 4 8.2 4a2.3 2.3 0 000 4.5', 'M12 8.5S13 4 15.8 4a2.3 2.3 0 010 4.5'],
  globe: ['M12 3a9 9 0 100 18 9 9 0 000-18z', 'M3.2 12h17.6', 'M12 3c2.8 3.3 2.8 14.7 0 18', 'M12 3c-2.8 3.3-2.8 14.7 0 18'],
  euro: ['M16.5 7.5a6 6 0 100 9', 'M4.5 11h8.5', 'M4.5 14h7'],
  'file-text': ['M6 3.5h7l5 5v12H6z', 'M13 3.5v5h5', 'M9 13h6', 'M9 16.5h6'],
  layers: ['M12 3l8 4.4-8 4.4-8-4.4z', 'M4 12l8 4.4 8-4.4', 'M4 16.4l8 4.4 8-4.4'],
  lock: ['M5.5 10.5h13V20a1 1 0 01-1 1h-11a1 1 0 01-1-1z', 'M8.5 10.5V8a3.5 3.5 0 017 0v2.5'],
  cloud: ['M7.2 18.5h9.6a3.6 3.6 0 00.3-7.2 5.4 5.4 0 00-10.3-.6 3.7 3.7 0 00.4 7.8z'],
  flame: ['M12 21a5 5 0 005-5c0-4.2-5-9.5-5-9.5s-.8 2.8-2.8 4.9S7 14.4 7 16a5 5 0 005 5z'],
  calendar: ['M4.5 5.5h15A1.5 1.5 0 0121 7v12a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 19V7a1.5 1.5 0 011.5-1.5z', 'M3 10.5h18', 'M8 3.5v4', 'M16 3.5v4'],
  warehouse: ['M3 20.5V10L12 5l9 5v10.5', 'M2.5 20.5h19', 'M7.5 20.5V14h9v6.5', 'M7.5 17h9'],
  calculator: ['M6 3.5h12a1.5 1.5 0 011.5 1.5v14A1.5 1.5 0 0118 20.5H6A1.5 1.5 0 014.5 19V5A1.5 1.5 0 016 3.5z', 'M8 7.5h8', 'M8.5 12h.5', 'M11.8 12h.4', 'M15 12h.5', 'M8.5 16h.5', 'M11.8 16h.4', 'M15 16h.5'],
  medical: ['M4.5 7.5h15A1.5 1.5 0 0121 9v9a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 18V9a1.5 1.5 0 011.5-1.5z', 'M9 7.5V6a1.5 1.5 0 011.5-1.5h3A1.5 1.5 0 0115 6v1.5', 'M12 11v5', 'M9.5 13.5h5'],
  search: ['M11 17a6 6 0 100-12 6 6 0 000 12z', 'M15.5 15.5L21 21'],
  cpu: ['M7.5 7.5h9v9h-9z', 'M10 4.5v3', 'M14 4.5v3', 'M10 16.5v3', 'M14 16.5v3', 'M4.5 10h3', 'M4.5 14h3', 'M16.5 10h3', 'M16.5 14h3'],
  'trending-down': ['M3.5 7.5l6 6 3.5-3.5 6.5 6.5', 'M20 11.5V17h-5.5'],
  'external-link': ['M18 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1h5', 'M15 3h6v6', 'M10 14L21 3'],
  alert: ['M12 3a9 9 0 100 18 9 9 0 000-18z', 'M12 8v5', 'M12 16h.01'],
};

/** Content files use richer names than the icon set; map them to the closest shape. */
const ALIASES: Record<string, string> = {
  'car-shield': 'car',
  'building-2': 'building',
  'heart-pulse': 'heart',
  'user-check': 'users',
  user: 'users',
  'calendar-x': 'calendar',
  'paint-roller': 'home',
  sofa: 'home',
  key: 'home',
  store: 'building',
  gavel: 'scale',
  chart: 'layers',
  wrench: 'bolt',
  repeat: 'bolt',
  luggage: 'package',
  microscope: 'search',
  stethoscope: 'medical',
  bandage: 'medical',
  tooth: 'medical',
  wheelchair: 'users',
  'file-check': 'file-text',
};

export interface IconProps {
  name: string;
  className?: string;
  strokeWidth?: number;
}

export function Icon({ name, className = 'h-6 w-6', strokeWidth = 1.6 }: IconProps) {
  const key = PATHS[name] ? name : (ALIASES[name] ?? 'shield');
  const paths = PATHS[key] ?? PATHS.shield;

  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      {paths.map((path) => (
        <path key={path} d={path} />
      ))}
    </svg>
  );
}
